import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconArrowDown = memo(
  ({ color = '#545454', size = 24, ...rest }) => {
    return (
      <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
        <Path fill={color} d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6-6-6z" />
      </Svg>
    );
  }
);
